import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { PslfFormExtension as PslfFormModel } from 'tio-data/data/resources/pslf-form.ext';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';

export default class AuthenticatedAdminPslfFormSignRoute extends Route {
  @service declare store: StoreService;

  queryParams = {
    signerType: { refreshModel: false },
  };

  async model(params: { form_id: string; signer: string }) {
    const { content } = (await this.store.request(
      findRecord<PslfFormModel>('pslf-form', params.form_id)
    )) as { content: { data: PslfFormModel } };
    return content.data;
  }
}
